import { OPEN_TEXT_SEARCH_EXPERIMENT } from '~/constants/common/openTextSearch';
import { PRICE_DROP_SUPPRESSION_EXPERIMENT } from '~/constants/common/priceDropSuppression';
import { CONDITIONAL_TILES_SUPPRESSION_EXPERIMENT } from '~/constants/srp/conditionalTilesSuppression';
import type { Experiment } from '~/server-utils/appRouter/fetchExperimentData';

export const clientSideBrowserCookieIdExperiments: Record<string, never> = {};

export const nccLipExperiment: Record<string, Experiment> = {
  'car-merch-ui-srp-ncc-lip4': {}
};

export const serverSideBrowserCookieIdExperiments = {
  [OPEN_TEXT_SEARCH_EXPERIMENT]: {},
  [PRICE_DROP_SUPPRESSION_EXPERIMENT]: {},
  [CONDITIONAL_TILES_SUPPRESSION_EXPERIMENT]: {},
  'car-merch-ui-srp-suggested-filters': {
    buckets: [
      'control',
      'hidecounts-1row',
      'showcounts-2row',
      'hidecounts-2row'
    ]
  },
  'car-merch-ui-srp-vdp-spa-v2': {},
  'quali-srp-carvanads': { buckets: ['control', 'survey'] }
};

export const clientSideUserIdExperiments = {};

// NOTE: Not currently wired up in the getExperiments middleware
export const serverSideUserIdExperiments = {};

export const clientSideExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments
};

export const serverSideExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const browserCookieIdExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...serverSideBrowserCookieIdExperiments
};

export const userIdExperiments = {
  ...clientSideUserIdExperiments,
  ...serverSideUserIdExperiments
};

export const experiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments,
  ...nccLipExperiment,
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const experimentNames = Object.keys(experiments);
